module.exports = __webpack_public_path__ + "static/media/holiday-party-catering-hero.aebb7bc2.jpg";